<template>
  <div class="page" v-loading="listLoading">
    <!--    导出-&#45;&#45;export-->
    <!--    订单详情-&#45;&#45;orderDetail-->
    <el-form @submit.native.prevent label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="子订单号:">
            <el-input v-model="searchData.orderNo" placeholder="子订单号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品名称:">
            <el-input v-model="searchData.productSkuName" placeholder="请输入商品名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收货人姓名:">
            <el-input v-model="searchData.receivingName" placeholder="收货人姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收货人电话:">
            <el-input v-model="searchData.receivingMobile" placeholder="收货人电话"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="外部订单号">
            <el-input v-model="searchData.OutOrderNo" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="供应商" prop="SupplierId">
            <el-select v-model="searchData.SupplierId" filterable remote placeholder="请选择 / 可搜索"
              :remote-method="querySupplier" style="width:100%">
              <el-option v-for="item in supplier" :key="item.id" :label="item.proSupplierName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="下单时间：">
            <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"
              style="width:100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <!--        <el-form-item label="采购单号:">-->
      <!--          <el-input v-model="searchData.orderPurchaseNo" placeholder="子订单号"></el-input>-->
      <!--        </el-form-item>-->
      <el-form-item>
        <div style="display: flex;">
          <el-button type="primary" @click="searchFun">查询</el-button>
          <el-button @click="resetFun">重置</el-button>
          <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
        </div>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
      @selection-change="selectCurrentRow" style="width: 100%" border>
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <el-table-column prop="orderNo" label="子订单号" width="300" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.orderNo }}</div>
          <p></p>
          <!--            platformOrderType 1  京东开普勒-->
          <el-tag size="mini" v-if="scope.row.platformType === 1 && scope.row.platformOrder" type="danger">京东订单
            {{ scope.row.receivingName }}已下单: {{ scope.row.platformOrder }}
          </el-tag>
          <p>
            <el-tag size="mini" v-if="scope.row.isHaveAfterOrder && scope.row.outOrderNo" effect="dark" type="danger">外部订单有售后订单</el-tag>
          </p>
        </template>
      </el-table-column>
      <el-table-column label="采购单号" width="150" align="center">
        <template slot-scope="scope">
          <span v-if="Array.isArray(scope.row.orderPurchases) && scope.row.orderPurchases.length > 0">{{
              scope.row.orderPurchases[0].orderPurchaseNo
          }}</span>

          <!--            {{ scope.row.orderPurchases[0]?.orderPurchaseNo }}-->

        </template>
      </el-table-column>
      <el-table-column prop="resellerName" label="订单来源" align="center" min-width="200"></el-table-column>
      <el-table-column prop="outOrderNo" label="外部订单号" width="200" align="center"></el-table-column>
      <el-table-column label="商品信息" width="250" align="center">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;"> {{
              scope.row.orderItems &&
              scope.row.orderItems[0] && scope.row.orderItems[0].productSkuName
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品规格" align="center" width="120">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;">{{
              scope.row.orderItems && scope.row.orderItems[0] &&
              scope.row.orderItems[0].productSpecExt ? scope.row.orderItems[0].productSpecExt : scope.row.orderItems[0].productSpec
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="商品供应商" width="150" align="center">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;"> {{
              scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="采购供应商" width="150" align="center">
        <template slot-scope="scope">
          {{
              scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName
          }}
        </template>
      </el-table-column>
      <el-table-column prop="stock" label="采购单价" width="120" align="center">
        <!--          purchasePrice-->
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;"> {{
              scope.row.orderPurchases &&
              scope.row.orderPurchases[0] && scope.row.orderPurchases[0].purchasePrice
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="stock" label="商品价格" width="120" align="center">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;"> {{
              scope.row.orderItems &&
              scope.row.orderItems[0] && scope.row.orderItems[0].unitPrice
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="creationTime" label="数量" width="200" align="center">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;"> {{
              scope.row.orderItems &&
              scope.row.orderItems[0] && scope.row.orderItems[0].quantity
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="payTotalAccount" label="订单金额" width="200" align="center">
        <!--          <template slot-scope="scope">-->
        <!--                        <span style="display: inline-block;margin-right:10px;"> {{-->
        <!--                            (scope.row.orderItems && scope.row.orderItems[0] && scope.row.orderItems[0].unitPrice)  *-->
        <!--                            (scope.row.orderItems &&    scope.row.orderItems[0] && scope.row.orderItems[0].quantity)-->
        <!--                          }}</span>-->
        <!--          </template>-->
      </el-table-column>
      <!--        <el-table-column prop="lastModificationTime" label="优惠信息" width="200" align="center"></el-table-column>-->
      <el-table-column prop="payTotalAccount" label="实付金额" width="200" align="center"></el-table-column>
      <el-table-column label="收货信息" width="200" align="center">
        <template slot-scope="scope">
          <span style="display: inline-block;margin-right:10px;"> {{ scope.row.receivingName }}</span>
          <span style="display: inline-block;margin-right:10px;"> {{ scope.row.receivingMobile }}</span>
          <span style="display: inline-block;margin-right:10px;"> {{ scope.row.receivingProviceName }},
            {{ scope.row.receivingCityName }},{{ scope.row.receivingDistrictName }},{{
                scope.row.receivingStreetName
            }}，{{ scope.row.receivingAddress }}</span>
        </template>
      </el-table-column>
      <el-table-column label="物流信息" width="400" align="center">
        <template slot-scope="scope" v-if="scope.row.orderLogistics.length">
          <div 
          @click="checkDeliveryDetail(item)" style="cursor:pointer;"
          v-for="(item, index) in scope.row.orderLogistics" :key="index">
            <span style="display: inline-block;margin-right:10px;text-decoration:underline">物流公司:{{ item.logisticsCompanyName }}
            </span>
            <span style="display: inline-block;margin-right:10px;text-decoration:underline">物流单号:{{ item.logisticsNo }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="200" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <!--            <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"-->
          <!--                       @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}-->
          <!--            </el-button>-->
          <el-button type="primary" @click="orderDetail(scope.row)" v-if="isDetailLogisShow" size="mini">详情
          </el-button>
          <el-button type="primary" @click="updateLogis(scope.row)" v-if="isUpdateLogisShow" size="mini">物流更新
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]"></el-pagination>
    <!-- 导入物流信息 -->
    <el-dialog title="导入物流信息" width="30%" :visible.sync="logisticsVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updataLogistics"
          :on-remove="removeLogistics">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo()">下载导入模板
            </el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="物流更新" :visible.sync="updateLoggisDialog" :show-close="false" :close-on-click-modal="false"
      width="80%">
      <el-table :data="updateLogisData" border style="width: 100%">
        <!--        <el-table-column-->
        <!--            prop="warehouseName"-->
        <!--            align="center"-->
        <!--            label="id"-->
        <!--            width="80">-->
        <!--        </el-table-column>-->
        <el-table-column prop="warehouseName" align="center" label="发货仓库" width="180">
        </el-table-column>
        <el-table-column align="center" prop="shipmentQuantity" label="总发货数量">
        </el-table-column>
        <!--        <el-table-column-->
        <!--            align="center"-->
        <!--            prop="logisticsCompanyName"-->
        <!--            label="物流公司">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column-->
        <!--            align="center"-->
        <!--            prop="logisticsNo"-->
        <!--            label="物流单号">-->
        <!--        </el-table-column>-->
        <el-table-column prop="shippedQuantity" align="center" label="更新物流数量">
        </el-table-column>
        <el-table-column align="center" label="物流记录">
          <template slot-scope="scope">
            {{ scope.row.logisticsStr | formatInfo }}
          </template>
        </el-table-column>
        <el-table-column width="250" prop="address" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="primary" @click="createLogis(scope.row)" v-if="isAddLogisShow" size="mini">新增</el-button>
            <el-button type="primary" @click="deleteLogis(scope.row)" v-if="isDelLogisShow" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--      <el-form label-width="100px">-->
      <!--        <el-form-item label="物流公司：">-->
      <!--          <el-autocomplete-->
      <!--              v-model="updateLogis.logisticsCompanyName"-->
      <!--              :fetch-suggestions="querySearchAsync"-->
      <!--              placeholder="请选择物流公司 可搜索"-->
      <!--              @select="handleSelect"-->
      <!--          ></el-autocomplete>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="物流单号">-->
      <!--          <el-col :span="8">-->
      <!--            <el-input-->
      <!--                v-model="updateLogis.logisticsNo"-->
      <!--            >-->
      <!--            </el-input>-->
      <!--          </el-col>-->

      <!--        </el-form-item>-->
      <!--        <el-form-item label='此单发货数量'>-->
      <!--          <el-col :span="8">-->
      <!--            <el-input-->
      <!--                v-model="updateLogis.logisticQuantity"-->
      <!--                placeholder="请输入发货数量"-->
      <!--            >-->
      <!--            </el-input>-->
      <!--          </el-col>-->
      <!--        </el-form-item>-->
      <!--      </el-form>-->
      <!--          </div>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateLogisCancel">取 消</el-button>
        <el-button type="primary" @click="updateLogisConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增物流" :visible.sync="createLoggisDialog" :show-close="false" :close-on-click-modal="false"
      width="40%">
      <!--          <div style="width:100%; margin-left:150px;">-->
      <el-form label-width="100px">
        <el-form-item label="物流公司：">
          <el-autocomplete v-model="addLogis.logisticsCompanyName" :fetch-suggestions="querySearchAsync1"
            placeholder="请选择物流公司 可搜索" @select="handleSelect1"></el-autocomplete>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input v-model="addLogis.logisticsNo">
          </el-input>
        </el-form-item>
        <el-form-item label='此单发货数量'>
          <el-input v-model="addLogis.currentShipmentQuantity">
          </el-input>
        </el-form-item>
      </el-form>
      <!--          </div>-->
      <span slot="footer" class="dialog-footer">
        <el-button @click="createLogisCancel">取 消</el-button>
        <el-button type="primary" @click="createLogisConfirm">确 定</el-button>
        <!--        <el-button type="primary" @click="createLogisConfirm">确 定</el-button>-->
      </span>
    </el-dialog>
    <el-dialog title="查询物流详情" :visible.sync="loggisDetailDialog" :show-close="false" :close-on-click-modal="false"
            width="40%">
      <div v-if="loggisDetailList.length">
        <div v-for="(item, i) in loggisDetailList" :key="i" style="margin-bottom:10px;padding-bottom:10px;border-bottom:1px dashed #eee">
          <p style="color:#999;font-size:12px;margin-bottom:5px;">{{item.time}}</p>
          <p style="color:#333;font-size:14px;">{{item.description}}</p> 
        </div>
      </div>
      <div v-if="loadLoggisDetailEnd&&!loggisDetailList.length" style="text-align:center;color:#999;font-size:14px;padding:30px 0;">暂无物流信息！</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="loggisDetailDialog=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  OrderPurchaseGetAll,
  OrderExport,
  OrderLogisticUpload,
  BatchCreate,
  OrderAfterSaleLogisticDelete,
  OrderWarehouseGetAll,
  brandGetAll,
  LogisticsCompanyServiceGetAll,
  SupplierGetAll,
  GetOrderLogistics
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      Ids: null,
      Name: null, //商品名称
      Model: null, //商品型号
      CategoryIds: null, //商品类型
      BrandIds: null, //品牌
      BeginCreationTime: null,
      EndCreationTime: null,
      PageIndex: 1, //页码
      PageSize: 10, //页长
      valueTime: [],
      total: 0,
      listLoading: false,
      currentRow: [],
      buttonList_toolBar: [],
      buttonList_table: [],
      brandName: '',
      tableList: [{ 'id': 1 }],
      productNavTypeTreeList: [],
      searchData: {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        orderNo: null,
        productSkuName: null,
        receivingName: null,
        receivingMobile: null,
        orderPurchaseNo: null,
        Status: 3,
        OutOrderNo: "",
        SupplierId: ""
      },
      value: '',
      options: [{
        value: '1',
        label: '待发货'
      }, {
        value: '2',
        label: '已发货'
      }],
      logisticsVisible: false,
      uploading: false,
      fileLog: null,
      currentId: null,
      updateLogisData: [],
      addLogis: {
        orderId: null,
        logisticsCompanyId: null,
        logisticsCompanyName: '',
        logisticsCompanyCode: '',
        logisticsNo: '',
        currentShipmentQuantity: null,
        orderPurchaseId: null,
        orderWarehouseId: null,
        // orderAfterSaleWarehouseId:null,
      },
      updateLoggisDialog: false,
      buttonLoading: false,
      isAddLogisShow: false,
      isDelLogisShow: false,
      createLoggisDialog: false,
      isDetailLogisShow: false,
      isUpdateLogisShow: false,
      supplier: [],
      
      loggisDetailDialog: false,
      loggisDetailList: [],
      loadLoggisDetailEnd: false,
      logisDetailShow: false
    };
  },
  filters: {
    formatInfo(vale) {
      console.log('====', vale)
      if (vale) {
        return vale.split(',').join('  |  ')
      }
    }
  },
  created() {
    // this.getProductNavTypeTree();
    // this.getBrandList();
    this.getTableList();
    this.querySupplier()
  },
  mounted() {
    this.getSpusOnSale();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });

      this.buttonList_toolBar = toolBarButtonList;
      console.log(' this.buttonList_toolBar', this.buttonList_toolBar)
      // const tableButtonList = buttonList.filter((item) => {
      //   return item.buttonShow === 20;
      // });
      // this.buttonList_table = tableButtonList;
      buttonList.forEach((item) => {
        if (item.buttonFunc === "logisDetail") {
          this.logisDetailShow = true;
        }
      })
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      tableButtonList.forEach((item) => {
        if (item.buttonFunc === "orderDetail") {
          this.isDetailLogisShow = true;
        }
      })
      tableButtonList.forEach((item) => {
        if (item.buttonFunc === "updateLogis") {
          this.isUpdateLogisShow = true;
        }
      })
      // updateLogis    deleteLogis
      tableButtonList.forEach((item) => {
        if (item.buttonFunc === "updateLogis") {
          this.isAddLogisShow = true;
        }
      })
      tableButtonList.forEach((item) => {
        if (item.buttonFunc === "deleteLogis") {
          this.isDelLogisShow = true;
        }
      })
      this.buttonList_table = tableButtonList;
      console.log(' this.buttonList_table', this.buttonList_table)
    }

  },
  methods: {
    checkDeliveryDetail(data) {
      if (!this.logisDetailShow) return 
      this.loggisDetailList = []
      this.loadLoggisDetailEnd = false
      this.loggisDetailDialog = true
      GetOrderLogistics({
        LogisticsCompanyCode: data.logisticsCompanyCode,
        LogisticsCode: data.logisticsNo
      }).then(res => {
        if (res.data.success) {
          this.loggisDetailList = res.data.result.data
        }
        this.loadLoggisDetailEnd = true
      })
    },
    exportBtn() {
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      OrderExport(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '订单列表数据.xlsx'
        a.href = objectUrl
        a.click()
        a.remove()
      })
    },
    importBtn() {
      this.logisticsVisible = true;
      this.fileLog = null;
    },
    upDataInfo() {
      window.open(
        "https://homeimage.ksaxshop.com/erp/order/%E8%AE%A2%E5%8D%95%E7%89%A9%E6%B5%81%E5%AF%BC%E5%85%A5.xlsx"
      );
    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type != "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    handleExpSubmit() {
      this.uploading = true;
      let formData = new window.FormData();
      formData.append("file", this.fileLog);
      OrderLogisticUpload(formData).then((res) => {
        if (!res.data.result) {
          this.$message.success('上传成功！');
          this.uploading = false;
          this.logisticsVisible = false;
          this.fileLog = null;
          this.getTableList();
        } else {
          this.$message.error(res.data.result);
          this.uploading = false;
        }
      });
    },
    async createLogisConfirm() {
      this.addLogis.orderId = this.currentId;
      console.log('新增物流 this.addLogis', this.addLogis);
      // return;
      this.buttonLoading = true;
      let res = await BatchCreate(this.addLogis);
      if (res.data.success) {
        this.createLoggisDialog = false;
        this.addLogis = {
          orderId: null,
          logisticsCompanyId: null,
          logisticsCompanyName: '',
          logisticsCompanyCode: '',
          logisticsNo: '',
          currentShipmentQuantity: null,
          orderPurchaseId: null,
          orderWarehouseId: null,
        };

        this.$message.success('新增成功')
        await this.freshAdd();
      } else {
        this.$message.error(res.data.result.message || '新增失败, 请重试')
      }
    },
    createLogisCancel() {
      this.createLoggisDialog = false;
      this.buttonLoading = false;
      this.addLogis = {
        logisticsCompanyId: null,
        logisticsCompanyName: '',
        logisticsCompanyCode: '',
        logisticsNo: '',
        currentShipmentQuantity: null,
        orderAfterSaleWarehouseId: null,
      }
    },
    deleteLogis(row) {
      console.log('物流删除 row', row);
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        let res = await OrderAfterSaleLogisticDelete({ id: row.id });
        if (res.data.success) {
          console.log('del success')
          this.$message.success(res.data.msg || '删除成功');
          await this.freshAdd();
        } else {
          this.$message.error(res.data.error.message || '删除失败, 请重试')
        }
      }).catch(() => {
      });
    },
    async freshAdd() {
      let res = await OrderWarehouseGetAll({ orderId: this.currentId });
      console.log('物流更新', res);
      if (res.data.success) {
        this.updateLogisData = res.data.result.items || [];
        console.log('updateLogisData', this.updateLogisData);
        // this.addLogis.orderId = row.orderId; // 新增物流用
        // this.updateLoggisDialog = true;
        this.$message.success('刷新物流信息成功')
      } else {
        return this.$message.error(res.data.error.message || '货物物流信息失败, 请重试')
      }
    },
    createLogis(row) {
      console.log('新增物流 row', row);
      // this.addLogis.orderAfterSaleWarehouseId = row.id;
      this.addLogis.orderWarehouseId = row.id;
      this.addLogis.orderPurchaseId = row.orderPurchaseId;
      this.createLoggisDialog = true;

    },
    updateLogisCancel() {
      this.updateLoggisDialog = false;
      this.getTableList();
    },
    updateLogisConfirm() {
      this.updateLoggisDialog = false;
      this.getTableList();
    },
    async updateLogis(row) {
      console.log('更新物流row9999', row)
      this.currentId = row.id; //新增 删除  刷新列表用
      this.addLogis.orderId = row.id;
      // this.updateLoggisDialog = true;
      let res = await OrderWarehouseGetAll({ orderId: row.id });
      console.log('物流更新', res);
      if (res.data.success) {
        this.updateLogisData = res.data.result.items || [];
        console.log('updateLogisData', this.updateLogisData);
        // this.addLogis.orderId = row.orderId; // 新增物流用
        this.updateLoggisDialog = true;
      } else {
        return this.$message.error(res.data.error.message || '货物物流信息失败, 请重试')
      }
    },
    orderDetail(row) {
      // this.$router.push(
      //   `/OrderManagement/Purchasing/OrderDetail?id=${row.id}`
      // );
    },
    querySupplier(value) {
      SupplierGetAll({
        SkipCount: 0,
        MaxResultCount: 100,
        supplierName: value
      }).then(res => {
        if (res.data.success) {
          this.supplier = res.data.result.items
        }
      })
    },
    async getTableList() {
      this.listLoading = true;
      let SkipCount = (this.searchData.PageIndex - 1) * this.searchData.PageSize;
      this.searchData.SkipCount = SkipCount;
      this.searchData.MaxResultCount = this.searchData.PageSize;
      let res = await OrderPurchaseGetAll(this.searchData);
      if (res.data.success) {
        this.total = res.data.result.totalCount;
        this.tableList = res.data.result.items;
      } else {
        // this.$message.error(res.data.result.message || '获取列表失败, 请重试')
      }
      setTimeout(() => {
        this.listLoading = false;
      }, 500)
      console.log('待shouh', res);
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    deleteGoods(item, index, row) {
      let list = []
      list.push(row.id)
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.getSpusOnSale()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    batchDelete() {
      if (!this.currentRow[0])
        return this.$message.error("请选择需要操作的商品");
      let list = this.currentRow.map((v) => {
        return v.id
      });
      ProductDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpusOnSale()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync1(queryString, cb) {
      if (queryString) {
        let res = await this.getAllCompany(queryString);
        cb(res);
      } else {
        let res = await this.getAllCompany();
        cb(res);
      }
    },
    getAllCompany(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.LogisticsCompanyName = key;
      }
      return new Promise((resolve, reject) => {
        LogisticsCompanyServiceGetAll(obj).then((res) => {
          console.log('物流公司list', res);
          if (res.data.success) {
            this.logisCompanyData = res.data.result.items
              .map((item) => {
                return {
                  value: item.fullName,
                  id: item.id,
                  code: item.expressHundredCode
                };
              });
            resolve(this.logisCompanyData);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
      console.log('this.logisCompanyData', this.logisCompanyData);
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.BrandIds = item.id;
    },
    handleSelect1(item) {
      console.log('物流公司', item);
      // this.form.logisticsCompanyId = item.id;
      // this.form.logisticsCompanyName = item.logisticsCompanyName;
      // this.form.logisticsCompanyCode = item.code;
      this.addLogis.logisticsCompanyId = item.id;
      this.addLogis.logisticsCompanyName = item.value;
      this.addLogis.logisticsCompanyCode = item.code;
    },
    clearBtn(val) {
      this.BrandIds = null
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({ parentId: 0 }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    searchFun() {
      this.PageIndex = 1;
      this.getTableList();
    },
    handlePicker(e) {
      console.log('llllll', e)
      if (e == null) {
        this.valueTime = []
        this.searchData.CreationStartTime = null;
        this.searchData.CreationEndTime = null;
      } else {
        this.searchData.CreationStartTime = e[0];
        this.searchData.CreationEndTime = e[1];
      }
    },
    resetFun() {
      this.searchData = {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        orderNo: null,
        productSkuName: null,
        receivingName: null,
        receivingMobile: null,
        orderPurchaseNo: null,
        Status: 3,
        CreationStartTime: null,
        CreationEndTime: null,
        OutOrderNo: "",
        SupplierId: ""
      };
      this.valueTime = [];
      this.getTableList();
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getTableList();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getTableList();
    },
    //获取商品列表
    getSpusOnSale() {
      let that = this;
      let para = {
        Ids: that.Ids,
        Name: that.Name, //商品名称
        Model: that.Model, //商品型号
        CategoryIds: that.CategoryIds, //商品类型
        BrandIds: that.BrandIds, //品牌
        BeginCreationTime: that.BeginCreationTime,
        EndCreationTime: that.EndCreationTime,
        SkipCount: (that.PageIndex - 1) * that.PageSize,
        MaxResultCount: that.PageSize,
      };
      // this.listLoading = false;
      // GetProductList(para).then((res) => {
      //   if (res.data.success) {
      //     if (res.data.result.items) {
      //       res.data.result.items.forEach(item => {
      //         item.IsSort = false
      //       })
      //     }
      //     this.total = res.data.result.totalCount;
      //     let list = res.data.result.items || [];
      //     list.forEach((item) => {
      //       item.popoverVisible = false;
      //     });
      //     this.tableList = list;
      //     this.listLoading = false;
      //   } else {
      //     this.$message.error(res.data.msg)
      //   }
      // });
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.id}`)
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path == "/Product/ComManagement/EditProduct") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
};
</script>

<style scoped>
.updata_view {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
